export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.501 3a3.001 3.001 0 010 6l-.087-.002-2.975 7.714A3 3 0 1112.502 19c0-.758.283-1.45.747-1.978l-3.206-5.572a2.996 2.996 0 01-1.474-.1l-2.45 3.186a3 3 0 11-1.507-1.321l2.373-3.085a3 3 0 115.517-1.63c0 .746-.275 1.427-.726 1.952l3.217 5.592A3.014 3.014 0 0115.57 16l2.98-7.724A3 3 0 0120.5 3zm-5 15a1 1 0 100 2 1 1 0 000-2zm-12-3a1 1 0 100 2 1 1 0 000-2zm6-7.5a1 1 0 100 2 1 1 0 000-2zm11-2.5a1 1 0 100 2 1 1 0 000-2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};